import "../components/HomeHeroStyles.css";
// import friggalogo from "../assets/homepagelogo.jpg";
import testfriggalogo from "../assets/homepagephotos/testfrigga.png";
// import friggabg from "../assets/stockvideo2compressed.mp4";
import backgroundvideo from "../assets/homepagevideo/frigga-new-homepage-video.mp4";


function HomeHero(props) {
  return (
    <>
      <div className={props.cName}>
        {/* <video  loop={true} muted={true} autoplay={true} playsinline={true} src={props.heroImg} alt="heroImg" /> */}
        
        {/* <video controls autoPlay loop muted>
            <source src={props.heroImg} type="video/mp4"/>
        </video> */}
        
        <video autoPlay loop playsInline muted>
            <source src={backgroundvideo} type="video/mp4"/>
        </video>

        {/* <img src={props.heroImg} alt="heroImg" /> */}
        <div className="home-hero-text">
          <img className="frigga-logo" src={testfriggalogo} alt="Frigga Consulting Group" />

          <div className="hero-initiative">
            <h1 className="hero-initiative-title">
              The Financial
              <span>Diplomacy Initiative</span>
            </h1>

            <p className="hero-initiative-pillars">
              INTEGRITY | STRATEGY | RESILIENCE | DIPLOMACY
            </p>

            <div className="hero-initiative-actions">
              <a className="hero-initiative-btn primary" href="/findip">
                EXPLORE INITIATIVE
              </a>
              <a className="hero-initiative-btn secondary" href="/insights">
                LEARN MORE
              </a>
            </div>
          </div>

          {props.title && <h1>{props.title}</h1>}
          {props.text && <p>{props.text}</p>}
          {props.buttonText && (
            <a className={props.btnClass} href={props.url}>
              {props.buttonText}
            </a>
          )}
        </div>
        {/* <h1>Your Journey Your Story</h1>
        <p>Choose Your Favourite Destination.</p>
        <a href="index.html">Travel Plan</a> */}
      </div>
    </>
  );
}

export default HomeHero;
